import type { StepRegistry } from '../StepRegistry';

function resolveCenter(params: { center: [number, number]; infraId?: string }, systems: any): [number, number] {
  if (params.infraId && systems.city) {
    const pos = systems.city.getInfraPosition(params.infraId);
    if (pos) return pos;
  }
  return params.center;
}

export function registerCameraSteps(registry: StepRegistry): void {
  registry.register('camera', async (step, systems, runner) => {
    runner.followingVehicleId = null;
    const center = resolveCenter(step.params, systems);
    await systems.camera.flyTo({ ...step.params, center, duration: step.duration });
  });

  registry.register('camera-orbit', async (step, systems, runner) => {
    runner.followingVehicleId = null;
    const center = resolveCenter(step.params, systems);
    await systems.camera.orbit({ ...step.params, center, duration: step.duration });
  });

  registry.register('camera-follow', async (step, systems, runner) => {
    const { vehicleId, pitch, zoom } = step.params;
    runner.followingVehicleId = vehicleId;

    await systems.camera.follow(
      () => systems.vehicles.getPosition(vehicleId),
      () => systems.vehicles.getBearing(vehicleId),
      step.duration,
      { pitch, zoom }
    );

    runner.followingVehicleId = null;
  });

  // Scenario-controlled dimming: starts and stays until dim-end
  registry.register('dim-start', async (_step, systems, runner) => {
    systems.vehicles.setScenarioVehicles(runner.getScenarioVehicleIds());
    systems.city?.dimNonHighlighted();
    systems.vehicles.dimAmbient();
  });

  registry.register('dim-end', async (_step, systems) => {
    systems.city?.exitScenarioMode();
    systems.vehicles.undimAll();
  });
}
